import { useState } from "react";

export enum CLONING_STEPS {
  CAMERA = "camera",
  CONFIRM = "confirm",
  PHOTO_SOURCE = "photoSource",
  VOICE = "voice",
  READY = "ready",
}

export const useCloningSteps = ({
  hasPhoto,
  hasVoiceSamples,
  isAllContactDataCollected,
}: {
  hasPhoto: boolean;
  hasVoiceSamples: boolean;
  isAllContactDataCollected: boolean;
}) => {
  const [step, setStep] = useState<CLONING_STEPS>();
  const isOnNameStep = !step;
  const isOnPhotoStep =
    step === CLONING_STEPS.CAMERA || step === CLONING_STEPS.PHOTO_SOURCE;
  const isOnVoiceStep = step === CLONING_STEPS.VOICE;
  const isOnConfirmStep = step === CLONING_STEPS.CONFIRM;

  const showCamera = step === CLONING_STEPS.CAMERA && !hasPhoto;
  const canProceedFromPhoto = isOnPhotoStep && hasPhoto;
  const canProceedFromVoice = isOnVoiceStep && hasVoiceSamples;

  const showNextButton =
    (isOnNameStep || canProceedFromPhoto || canProceedFromVoice) &&
    !isOnConfirmStep;

  const showConfirmButton = isOnConfirmStep && isAllContactDataCollected;

  const showBackButton =
    (isOnPhotoStep && !hasPhoto) ||
    (isOnVoiceStep && !hasVoiceSamples) ||
    isOnConfirmStep;

  const showResetButton =
    (isOnPhotoStep && hasPhoto) || (isOnVoiceStep && hasVoiceSamples);
  const showResetPhotoText = isOnPhotoStep && hasPhoto;
  return {
    step,
    setStep,
    showCamera,
    showNextButton,
    showConfirmButton,
    showBackButton,
    showResetButton,
    showResetPhotoText,
  };
};
